// extracted by mini-css-extract-plugin
module.exports = {"collections":"collections___2gL3o","collection":"collection___1EkDr","card":"card___iW1OK","cover":"cover___3YXBh"};